module.exports = require('./components/ReadMoreReact');